import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { Router } from '@angular/router';
import type { MailingFormInterface } from '@zaoblako/shared/modules/notification/dtos/mailing/mailing-form.dto';
import { ErrorService } from '@zaoblako/web/core/services/error.service';
import { MailingService } from '@zaoblako/web/core/services/report/mailing.service';
import { TenantService } from '@zaoblako/web/core/services/security/tenant.service';
import { DatepickerComponent } from '@zaoblako/web/shared/dumbs/datepicker/datepicker.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import * as moment from 'moment-timezone';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'crm-newsletter-welcome-system-change-planning',
  standalone: true,
  imports: [CommonModule, ButtonModule, SpinnerComponent, DatepickerComponent],
  templateUrl: './newsletter-welcome-system-change-planning.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsletterWelcomeSystemChangePlanningComponent implements OnInit {
  public loading = false;
  @Input() public newsletter: MailingFormInterface;

  @Output() public closeModal = new EventEmitter<void>();

  public constructor(
    private readonly mailingService: MailingService,
    private readonly tenantService: TenantService,
    private readonly errorService: ErrorService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly router: Router
  ) {}

  public ngOnInit() {
    this.newsletter.includingAdvancePayment = false;
    this.newsletter.date = moment().startOf('minute').toDate();
  }

  public startMailing() {
    this.loading = true;
    this.cdRef.markForCheck();

    this.mailingService.create(this.newsletter).subscribe({
      next: () => {
        this.loading = false;
        this.cdRef.markForCheck();
        this.tenantService.disableDebitWelcome().subscribe();
        this.errorService.addSuccessMessage('Рассылка создана');
        this.closeModal.emit();
        this.router.navigate(['debts/newsletter']).catch(console.error);
      },
      error: () => {
        this.loading = false;
        this.cdRef.markForCheck();
      }
    });
  }
}
